import { render, staticRenderFns } from "./AudioPlay.vue?vue&type=template&id=116fed92&scoped=true"
import script from "./AudioPlay.vue?vue&type=script&lang=js"
export * from "./AudioPlay.vue?vue&type=script&lang=js"
import style0 from "./AudioPlay.vue?vue&type=style&index=0&id=116fed92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116fed92",
  null
  
)

export default component.exports